<template>
  <div class="gerenxinxi" style="width: 70%; margin: 0 auto">
    <div class="grxx-container">
      <div
        class="rczp-title"
        style="font-size: 20px; color: #4caff7; margin-bottom: 10px"
      >
        基本信息
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">企业名称：</span>
          <input
            placeholder="请输入"
            v-model="company.companyName"
            class="rczp-form-input"
          />
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">企业<br />联系人：</span>
          <input
            placeholder="请输入"
            v-model="company.companyCorporation"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">联系人<br />电话：</span>
          <input
            placeholder="请输入"
            v-model="company.companyTelephone"
            class="rczp-form-input"
          />
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">企业位置：</span>
          <input
            placeholder="请输入"
            v-model="company.companyAddress"
            class="rczp-form-input"
          />
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">营业执照：</span>
          <el-upload
            class="avatar-uploader"
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="yyzzHandleUploadSuccess"
            :before-upload="handleBeforeUpload"
            :headers="headers"
            :limit="1"
          >
            <img v-if="company.filePath" :src="company.filePath" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div
              slot="tip"
              class="el-upload__tip"
              style="text-align: center; font-size: 14px; color: #f49d1a"
            >
              温馨提示:请上传营业执照
            </div>
          </el-upload>
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">公司logo：</span>
          <el-upload
            class="avatar-uploader"
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="logoHandleUploadSuccess"
            :before-upload="handleBeforeUpload"
            :headers="headers"
            :limit="1"
          >
            <img v-if="company.companyLogo" :src="company.companyLogo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div
              slot="tip"
              class="el-upload__tip"
              style="text-align: center; font-size: 14px; color: #f49d1a"
            >
              温馨提示:请上传公司logo
            </div>
          </el-upload>
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">公司资质：</span>
          <el-upload
            class="avatar-uploader"
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="zzHandleUploadSuccess"
            :before-upload="handleBeforeUpload"
            :headers="headers"
            :limit="1"
          >
            <img
              v-if="company.companyQualification"
              :src="company.companyQualification"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div
              slot="tip"
              class="el-upload__tip"
              style="text-align: center; font-size: 14px; color: #f49d1a"
            >
              温馨提示:请上传公司资质
            </div>
          </el-upload>
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">企业简介：</span>
          <textarea
            placeholder="请输入企业简介"
            rows="4"
            maxlength="200"
            v-model="company.companyIntroduce"
          ></textarea>
        </div>
      </div>
      <div class="btn-box">
        <button type="button" class="common-btn my-btn blackRegistrationPage">
          <router-link to="/registrationPage">返回注册页面</router-link>
        </button>
        <button type="button" class="common-btn my-btn" @click="updateUserInfo()">
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import axios from "axios";
import request from "@/request";
export default {
  data() {
    return {
      company: {},
      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileList: [],
      fjFileList: [],
      userInfo: {},
      uploadInst: null,
      cropperObj: null,
      cutImage: false,
      fileType: ["png", "jpg", "jpeg"],
    };
  },
  activated() {
    let _this = this;
    //   _this.getUserInfo();
    //   _this.getResume();
  },
  methods: {
    getCompanyInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.company = res.data;
            // _this.userInfo = res.data.user;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    uploadPic(val) {
      $("#uploadImg").attr("data-type", val);
      $("#uploadImg").click();
    },
    uploadHead() {
      $("#imgReader").click();
      if (this.cropperObj) {
        this.cropperObj.destroy();
      }
    },
    loadingImg(event) {
      let _this = this;
      _this.cutImage = true;
      _this.$layer.open({
        title: "图片剪裁",
        type: 1,
        skin: "custom-layer",
        content: $("#cutImage"),
        area: ["680px", "580px"],
        btn: ["确认"],
        success: () => {
          //读取上传文件
          let reader = new FileReader();
          if (event.target.files[0]) {
            //readAsDataURL方法可以将File对象转化为data:URL格式的字符串（base64编码）
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e) => {
              let dataURL = reader.result;
              //将img的src改为刚上传的文件的转换格式
              document.querySelector("#cropImg").src = dataURL;
              const image = document.getElementById("cropImg");
              image.onload = () => {
                if (image.width > image.height) {
                  image.style.width = "480px";
                } else {
                  image.style.height = "480px";
                }
                //创建cropper实例
                _this.cropperObj = new Cropper(image, {
                  aspectRatio: 16 / 16,
                  viewMode: 0,
                  minContainerWidth: 480,
                  minContainerHeight: 480,
                  dragMode: "move",
                  preview: [
                    document.querySelector(".previewBox"),
                    document.querySelector(".previewBoxRound"),
                  ],
                });
              };
            };
          }
        },
        yes: (index) => {
          _this.cropperObj
            .getCroppedCanvas({
              maxWidth: 4096,
              maxHeight: 4096,
              fillColor: "#fff",
              imageSmoothingEnabled: true,
              imageSmoothingQuality: "high",
            })
            .toBlob((blob) => {
              //然后调用浏览器原生的toBlob方法将canvas数据转换成blob数据
              //之后就可以愉快的将blob数据发送至后端啦，可根据自己情况进行发送，我这里用的是axios
              const formData = new FormData();
              // 第三个参数为文件名，可选填.
              formData.append("file", blob, "example.png");
              let config = {
                headers: { "Content-Type": "multipart/form-data" },
              };
              axios
                .post(
                  `${request.uploadFile}&Authentication=${_this.$cookies.get(
                    _this.$commons.User.Authentication
                  )}`,
                  formData,
                  config
                )
                .then((response) => {
                  if (response.data.errorCode == _this.$commons.RespCode.success) {
                    _this.userInfo.headUrl = response.data.data.path;
                  } else {
                    _this.$layer.alert("图片上传失败");
                  }
                  document.querySelector("#cropImg").src = "";
                  _this.$layer.close(index);
                  _this.cutImage = false;
                })
                .catch((err) => {});
            });
        },
        cancel: (index) => {
          document.querySelector("#cropImg").src = "";
          _this.$layer.close(index);
          _this.cutImage = false;
        },
      });
    },
    picUpload() {
      let _this = this;
      _this.uploadInst.reload({
        before: function () {
          _this.$layer.load(0, { shade: false });
        },
        done: function (res) {
          if (res.errorCode == _this.$commons.RespCode.needLogin) {
            _this.$router.push({
              path: "/login",
            });
          } else if (res.errorCode == _this.$commons.RespCode.success) {
            let type = $("#uploadImg").attr("data-type");
            _this.studentInfo[type] = res.data.path;
            _this.$forceUpdate();
          } else {
            _this.$layer.alert("图片上传失败");
          }
          _this.$layer.closeAll("loading");
        },
        error: function () {
          _this.$layer.closeAll("loading");
        },
      });
    },

    // 上传成功回调
    logoHandleUploadSuccess(res) {
      let _this = this;
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.company.companyLogo = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    zzHandleUploadSuccess(res) {
      let _this = this;
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.company.companyQualification = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    zzHandleUploadSuccess(res) {
      let _this = this;
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.company.companyQualification = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    yyzzHandleUploadSuccess(res) {
      let _this = this;
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.company.filePath = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },

    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      // if (this.fileType.length) {
      //   let fileExtension = "";
      //   if (file.name.lastIndexOf(".") > -1) {
      //     fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
      //   }
      //   isImg = this.fileType.some((type) => {
      //     if (file.type.indexOf(type) > -1) return true;
      //     if (fileExtension && fileExtension.indexOf(type) > -1) return true;
      //     return false;
      //   });
      // } else {
      //   isImg = file.type.indexOf("image") > -1;
      // }

      // if (!isImg) {
      //   this.$modal.msgError(
      //     `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
      //   );
      //   return false;
      // }
      // const isLt = file.size / 1024 / 1024 < 5;
      // if (!isLt) {
      //   this.$modal.msgError(`上传头像图片大小不能超过 5MB!`);
      //   return false;
      // }

      this.$modal.loading("正在上传图片，请稍候...");
    },
    updateUserInfo() {
      let _this = this;
      if (!_this.company.companyName) {
        _this.$layer.alert("请输入企业名称!");
        return;
      }
      if (!_this.company.companyCorporation) {
        _this.$layer.alert("请输入企业联系人!");
        return;
      }
      if (!_this.company.companyTelephone) {
        _this.$layer.alert("请输入联系人电话!");
        return;
      } else {
        let myreg = new RegExp(
          "^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$"
        );
        if (!myreg.test(_this.company.companyTelephone)) {
          _this.$layer.alert("联系人电话格式错误!");
          return;
        }
      }
      if (!_this.company.companyAddress) {
        _this.$layer.alert("请输入企业地址!");
        return;
      }
      // if (!_this.company.filePath) {
      //   _this.$layer.alert("请上传营业执照!");
      //   return;
      // }
      // if (!_this.company.companyLogo) {
      //   _this.$layer.alert("请上传公司logo!");
      //   return;
      // }
      // if (!_this.company.companyQualification) {
      //   _this.$layer.alert("请上传公司资质!");
      //   return;
      // }
      if (!_this.company.companyIntroduce) {
        _this.$layer.alert("请输入企业简介!");
        return;
      }
      let param = {
        // id: _this.company.id,
        companyName: _this.company.companyName,
        companyCorporation: _this.company.companyCorporation,
        companyTelephone: _this.company.companyTelephone,
        companyAddress: _this.company.companyAddress,
        filePath: _this.company.filePath,
        companyLogo: _this.company.companyLogo,
        companyQualification: _this.company.companyQualification,
        companyIntroduce: _this.company.companyIntroduce,
      };
      _this.$api.enterprise
        .register(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.$layer.alert(
              "注册成功!账号和密码为联系人电话",
              { icon: 1, closeBtn: 0 },
              function (index) {
                _this.$layer.close(index);
                _this.$router.push({ name: "login" });
              }
            );
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<style>
.cropImgContent {
  width: 480px;
  float: left;
}

.cropImgContent img {
  box-shadow: 0 0 5px #adadad;
}

.previewContent {
  float: left;
  margin-left: 52px;
}

.previewContent .previewText {
  font-size: 16px;
  margin-top: 16px;
  text-align: center;
}

.previewContent .previewBox,
.previewContent .previewBoxRound {
  box-shadow: 0 0 5px #adadad;
  width: 100px;
  height: 100px;
  margin-top: 20px;
  overflow: hidden;
  /*这个超出设置为隐藏很重要，否则就会整个显示出来了*/
}

.blackRegistrationPage {
  background-color: #409eff;
  color: #ffffff;
}

.previewContent .previewBoxRound {
  border-radius: 50%;
  /*设置为圆形*/
  margin-top: 40px;
}

body .custom-layer .layui-layer-title {
  background: #be1a21;
  color: #fff;
  border: none;
}

body .custom-layer .layui-layer-btn {
  border-top: 1px solid #e9e7e7;
}

body .custom-layer .layui-layer-btn a {
  background: #be1a21;
  border-color: #be1a21;
}

body .custom-layer .layui-layer-btn .layui-layer-btn1 {
  background: #be1a21;
}

select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}

.el-upload__input {
  display: none !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.rczp-row textarea {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  width: 100%;
  padding: 11px 0 5px 12px;
  margin-top: 10px;
  resize: none;
  outline: none;
  border: none;
  border-bottom: 1px solid #ededed;
}

select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}

.append_content {
  margin: 40px auto !important;
  width: 890px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.appendList {
  display: flex;
  flex-flow: column;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 206px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgb(208 208 208 / 50%);
  border-radius: 10px;
  transition: all 0.2s;
  padding-top: 10px;
}

.appendList:hover {
  cursor: pointer;
  box-shadow: 10px 6px 40px rgb(208 208 208);
}

.append_image {
  height: 128px;
  width: 250px;
  /* background-color: #00F7DE; */
  margin: auto;
}

.append_image img {
  height: 100%;
  max-width: 100%;
}

.append_name {
  height: 30px;
  width: 250px;
  margin: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s;
}

.append_btn {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  padding: 5px;
}

.appendList:hover .append_name {
  color: #409eff !important;
  transform: scale(1.02);
  font-weight: 600;
}

.showEdit {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/enterprise/register.vue